import ReactOnRails from 'react-on-rails';

// getStore throws when no store is hydrated at all, even with throwIfMissing false
export default (slice, key) =>
  (key && ReactOnRails.stores?.().get?.('Store')?.getState?.()?.prefetched?.[slice]?.[key]) || null;
